import { useLocation } from "react-router-dom";

// eslint-disable-next-line import/prefer-default-export
export function useNullableCallToken() {
  const location = useLocation();
  const token = (location.state as { callToken?: string } | null)?.callToken;
  if (!token) {
    return { callToken: null, encodedToken: null };
  }
  return { callToken: atob(token), encodedToken: token };
}
